import React, { useId } from 'react';
import { Path } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconSplit = ({ ...props }) => {
    const id = useId();
    return (<IconWithGradient id={id} defaultGradientKey="lime" {...props}>
      <Path d="M11.182 4.318v6.546a.819.819 0 0 1-.818.818H3.818A.818.818 0 0 1 3 10.864V4.318a.818.818 0 0 1 .818-.818h6.546a.818.818 0 0 1 .818.818Zm-.818 9H3.818a.818.818 0 0 0-.818.818v6.546a.818.818 0 0 0 .818.818h6.546a.819.819 0 0 0 .818-.818v-6.546a.819.819 0 0 0-.818-.818ZM20.182 3.5h-6.546a.818.818 0 0 0-.818.818v16.364a.819.819 0 0 0 .818.818h6.546a.819.819 0 0 0 .818-.818V4.318a.818.818 0 0 0-.818-.818Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
